import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { User } from "src/services/dto/Security";

import ProviderProfile from "@containers/ProviderProfile";

import { getRecordId } from "@utils/helpers";

type ProviderSelectorProps = {
  open: boolean;
  selectedId?: string;
  handleClose: () => void;
  handleSelect: (provider: User) => void;
  providers: User[];
};

const ProviderSelector = ({
  open,
  selectedId,
  providers,
  handleClose,
  handleSelect,
}: ProviderSelectorProps) => {
  const [selected, setSelected] = useState<Partial<User>>(() => ({
    id: selectedId,
  }));

  return (
    <Dialog fullScreen open={open}>
      <DialogContent sx={{ backgroundColor: "background.default" }}>
        <Grid container spacing={2}>
          {providers.map((provider) => {
            const providerId = getRecordId(provider);
            const selectProviderId = getRecordId(selected);
            const isSelected = providerId === selectProviderId;

            return (
              <Grid key={getRecordId(provider)} item xs={12} md={4}>
                <Box
                  onClick={() => setSelected(provider)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 1,
                    padding: isSelected ? 0.25 : 0,
                    backgroundColor: isSelected ? "primary.main" : "none",
                  }}
                >
                  <ProviderProfile provider={provider}>
                    <Button
                      variant="contained"
                      fullWidth
                      disableRipple
                      sx={{
                        borderRadius: 0,
                        ...(!isSelected
                          ? {
                              backgroundColor: "background.light",
                              "&:hover": {
                                backgroundColor: "primary.main",
                              },
                            }
                          : {
                              "&:hover": {
                                backgroundColor: "primary.main",
                              },
                            }),
                      }}
                    >
                      {isSelected && (
                        <CheckCircleOutlineOutlinedIcon
                          sx={{ color: "common.white", mr: 0.5 }}
                        />
                      )}
                      {isSelected ? "Provider Selected" : "Select Provider"}
                    </Button>
                  </ProviderProfile>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: 2,
          backgroundColor: "background.default",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            setSelected({
              id: selectedId,
            });
            handleClose();
          }}
        >
          Keep Current
        </Button>
        <Button
          variant="contained"
          onClick={() => handleSelect(selected as User)}
        >
          Confirm New Doctor
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProviderSelector;
